<template>
  <v-card
    :id="part + '-inspiration'"
    flat
    dark
    class="pa-4 ma-2 mr-0 primaryGradientBackground"
    height="100%"
  >
    <div class="text-h5 mb-2">
      {{ $t('article.inspirationFor.title', [$t('article.label.' + part)]) }}
    </div>
    <div
      v-for="(inspiration, index) of Object.values(inspirations)"
      :key="index"
    >
      <ArticleInspirationPart
        :site="inspiration.site"
        :content="inspiration[part]"
        :words-to-highlight="wordsToHighlight"
        :small-width="true"
      />
    </div>
    <v-skeleton-loader
      v-if="loadingInspirations"
      :type="'paragraph@' + skeletonCounter"
      class="skeleton-right"
    />
    <span
      v-if="showNoInspiration"
      class="caption text--disabled"
    >
      {{ $t('article.noInspiration') }}
    </span>
  </v-card>
</template>

<script lang="ts">
    import Vue, {PropType} from "vue";
    import ArticleInspirationPart from "@/components/article/ArticleInspirationPart.vue";
    import ArticleInspirationMixin from "@/mixins/ArticleInspirationMixin";

    export default Vue.extend({
        name: "ArticleMetaInspirations",
        components: {ArticleInspirationPart},
        mixins: [ArticleInspirationMixin],
        props: {
            wordsToHighlight: {
                type: Object as PropType<{[key: string]: string[] }>,
                default: () => ({})
            }
        },
        computed: {
            inspirationsForPart: function (): number {
                // @ts-ignore - in mixin
                return Object.values(this.inspirations)
                    // @ts-ignore - in mixin
                    .map((site: any) => site[this.part as string] === null ? 0 : 1)
                    .reduce((a: number, b: number) => a + b, 0);
            }
        }
    });
</script>

<style lang="sass">
.metaInspirationScroll
    max-height: 75vh
    overflow: auto
    direction: rtl

    & > *
        direction: ltr

.skeleton-right .v-skeleton-loader__paragraph .v-skeleton-loader__text
    background: rgba(255, 255, 255, 0.5)
    &:after
        background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0))
    &:nth-child(2)
        margin-left: 50%

    &:nth-child(3)
        margin-left: 30%
</style>
